import React from 'react';
import { Backdrop, Container, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 24,
    position: 'relative',
    transform: ({ scale }) => `scale(${scale})`,
    width: 960,
  },
  footer: {
    bottom: 0,
    left: 0,
    pointerEvents: 'none',
    position: 'absolute',
  },
  header: {
    left: 0,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
  },
  root: {
    pointerEvents: 'all',
    zIndex: 1,
  },
}));

const ContentDialog = ({ children, headerImg, footerImg }) => {
  const scale =
    window.innerWidth > window.innerHeight
      ? window.innerHeight / 720
      : window.innerWidth / 1280;
  const { container, footer, header, root } = useStyles({ scale });
  return (
    <Backdrop className={root} open={true}>
      <Container component={Paper} className={container} maxWidth="md">
        <img className={footer} src={footerImg} alt="footer" />
        {children}
        <img className={header} src={headerImg} alt="header" />
      </Container>
    </Backdrop>
  );
};

export default ContentDialog;
